
import React, { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

interface DailyQuoteProviderProps {
  onQuoteLoaded: (quote: string) => void;
}

export const DailyQuoteProvider: React.FC<DailyQuoteProviderProps> = ({ onQuoteLoaded }) => {
  const { toast } = useToast();

  useEffect(() => {
    const fetchDailyQuote = async () => {
      try {
        const today = new Date().toDateString();
        const cachedQuote = localStorage.getItem('dailyQuote');
        const cacheDate = localStorage.getItem('dailyQuoteDate');

        if (cachedQuote && cacheDate === today) {
          onQuoteLoaded(cachedQuote);
          return;
        }

        const { data, error } = await supabase.functions.invoke('get-cat-quote');
        
        if (error) throw error;
        
        if (data.quote) {
          onQuoteLoaded(data.quote);
          localStorage.setItem('dailyQuote', data.quote);
          localStorage.setItem('dailyQuoteDate', today);
        }
      } catch (error) {
        console.error('Error fetching daily quote:', error);
        toast({
          title: "Error fetching quote",
          description: "Could not load today's inspirational quote.",
          variant: "destructive"
        });
      }
    };

    fetchDailyQuote();
  }, [onQuoteLoaded]);

  return null;
};
